/**
 * Telemetry event test IDs for Adobe Analytics.
 * Pattern: myclass|<page>|<action>|<sub-action>
 *
 * Reference: https://quip-amazon.com/SvFDAzgL2Shs/myClass-Adobe-Analytics-Telemetry
 */
const PREFIX = 'myclass';
const DASHBOARD = `${PREFIX}|dashboard`;
const COURSE_DETAIL = `${PREFIX}|course-detail-page`;

const pageAction = (action: string) => ({
    DASHBOARD_CLICK: `${DASHBOARD}|${action}|click`,
    COURSE_DETAIL_CLICK: `${COURSE_DETAIL}|${action}|click`,
});

const ENROLL = pageAction('enroll');
const WITHDRAW = pageAction('withdraw');
const WAITLIST = pageAction('waitlist');
const UNWAITLIST = pageAction('unwaitlist');
const CERTIFICATE = pageAction('certificate');
const REQUEST_ACCESS = pageAction('request-access');
const JOIN_TRAINING = pageAction('join-training');
const BUILDER_LABS = pageAction('builder-labs');
const EVALUATION_SURVEY = pageAction('evaluation-survey');

export const TelemetryEvents = {
    DASHBOARD_ENROLL_CLICK: ENROLL.DASHBOARD_CLICK,
    COURSE_DETAIL_ENROLL_CLICK: ENROLL.COURSE_DETAIL_CLICK,
    DASHBOARD_WITHDRAW_CLICK: WITHDRAW.DASHBOARD_CLICK,
    COURSE_DETAIL_WITHDRAW_CLICK: WITHDRAW.COURSE_DETAIL_CLICK,
    DASHBOARD_WAITLIST_CLICK: WAITLIST.DASHBOARD_CLICK,
    COURSE_DETAIL_WAITLIST_CLICK: WAITLIST.COURSE_DETAIL_CLICK,
    DASHBOARD_UNWAITLIST_CLICK: UNWAITLIST.DASHBOARD_CLICK,
    COURSE_DETAIL_UNWAITLIST_CLICK: UNWAITLIST.COURSE_DETAIL_CLICK,
    DASHBOARD_CERTIFICATE_CLICK: CERTIFICATE.DASHBOARD_CLICK,
    COURSE_DETAIL_CERTIFICATE_CLICK: CERTIFICATE.COURSE_DETAIL_CLICK,
    DASHBOARD_REQUEST_ACCESS_CLICK: REQUEST_ACCESS.DASHBOARD_CLICK,
    COURSE_DETAIL_REQUEST_ACCESS_CLICK: REQUEST_ACCESS.COURSE_DETAIL_CLICK,
    DASHBOARD_JOIN_TRAINING_CLICK: JOIN_TRAINING.DASHBOARD_CLICK,
    COURSE_DETAIL_JOIN_TRAINING_CLICK: JOIN_TRAINING.COURSE_DETAIL_CLICK,
    DASHBOARD_BUILDER_LABS_CLICK: BUILDER_LABS.DASHBOARD_CLICK,
    COURSE_DETAIL_BUILDER_LABS_CLICK: BUILDER_LABS.COURSE_DETAIL_CLICK,
    DASHBOARD_EVALUATION_SURVEY_CLICK: EVALUATION_SURVEY.DASHBOARD_CLICK,
    COURSE_DETAIL_EVALUATION_SURVEY_CLICK: EVALUATION_SURVEY.COURSE_DETAIL_CLICK,
    DASHBOARD_TAB_CHANGE: `${DASHBOARD}|tab-change`,
    COURSE_DETAIL_TAB_CHANGE_ABOUT: `${COURSE_DETAIL}|tab-change|about`,
    COURSE_DETAIL_TAB_CHANGE_OUTLINE: `${COURSE_DETAIL}|tab-change|outline`,
    COURSE_DETAIL_TAB_CHANGE_CLOUD_QUEST: `${COURSE_DETAIL}|tab-change|cloud-quest`,
    COURSE_DETAIL_OPEN_CLOUD_QUEST_CLICK: `${COURSE_DETAIL}|open-cloud-quest|click`,
    COURSE_DETAIL_TAB_CHANGE_PREMIUM_CONTENT: `${COURSE_DETAIL}|tab-change|premium-content`,
    COURSE_DETAIL_TAB_CHANGE_CLASS_CONTENT: `${COURSE_DETAIL}|tab-change|class-content`,
    COURSE_DETAIL_PREMIUM_CONTENT_LAUNCH_CLICK: `${COURSE_DETAIL}|premium-content-launch|click`,
    DASHBOARD_COURSE_TITLE_CLICK: `${DASHBOARD}|course-title|click`,
} as const;

export const TelemetryPage = {
    DASHBOARD: 'dashboard',
    COURSE_DETAIL: 'course-detail-page',
} as const;

export type TelemetryPage = (typeof TelemetryPage)[keyof typeof TelemetryPage];

export enum TELEMETRY_EVENT_TYPES {
    CLICK = 'click',
    LINK_CLICK = 'linkClick',
    TOOL = 'tool',
    TOOL_START = 'toolStart',
    TOOL_COMPLETE = 'toolComplete',
    TOOL_RESUME = 'toolResume',
}
